/*
* アコーディオン
*/
export default class Accordion {
  constructor() {
    this.$accordionTrigger = document.querySelectorAll('[data-target="accordionTrigger"]');
  }

  attachEvent() {
    Array.prototype.forEach.call( this.$accordionTrigger, $trigger => {
      $trigger.addEventListener('click', () => {
        if($trigger.classList.contains('is-open')) {
          $trigger.classList.remove('is-open');
        } else {
          $trigger.classList.add('is-open');
        }
      });
    });
  }
}
